import { flattenCategories } from "@fry-it/risr-core";
import { BLUEPRINT_TYPES } from "./blueprint-types";

export interface BlueprintApiCategory {
    _id: string;
    name: string;
    description: string;
    categories: BlueprintApiCategory[];
    value: number;
}

export interface BlueprintApiResponse {
    _id: string;
    _rev: string;
    categories?: BlueprintApiCategory[];
    name: string;
    blueprintType: keyof typeof BLUEPRINT_TYPES;
    type: string;
    restrictable: boolean;
    usage: ('events' | 'goal_periods')[];
    organisation: string;
    modifiedDate: string;
    systemModifiedDate: string;
}

export interface BlueprintCategory {
    _id: string;
    name: string;
    description: string;
    value: number;
    categories: BlueprintCategory[];
}

export class Blueprint {
    id: string;
    rev: string;
    categories?: BlueprintCategory[];
    name: string;
    blueprintType: keyof typeof BLUEPRINT_TYPES;
    type: string;
    restrictable: boolean;
    usage: ('events' | 'goal_periods')[];
    organisation: string;
    modifiedDate: string;
    systemModifiedDate: string;

    private constructor(data: Partial<Blueprint> = {}) {
        Object.assign(this, data);
    }

    static fromApiResponse(response: BlueprintApiResponse): Blueprint {
        return new Blueprint({
            id: response._id,
            rev: response._rev,
            categories: response.categories,
            name: response.name,
            blueprintType: response.blueprintType,
            type: response.type,
            restrictable: response.restrictable,
            usage: response.usage,
            organisation: response.organisation,
            modifiedDate: response.modifiedDate,
            systemModifiedDate: response.systemModifiedDate
        });
    }

    flatCategories(): BlueprintCategory[] {
        if (this.categories === undefined) {
            return [];
        }
        return flattenCategories(this.categories);
    }
}